import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import logoSvg from '@/assets/logo.svg';
import { trackCtaClick } from '@/lib/trackCtaClick.ts';
import { scrollToApplyForm } from '@/lib/scroll';
import { LanguageSwitcher } from '@/components/LanguageSwitcher.tsx';
import { TestIds } from '@/constants/testIds';

export const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleApplyClick = () => {
    trackCtaClick('header');
    scrollToApplyForm();
  };

  return (
    <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-lg mx-auto px-5 py-3 flex items-center justify-between">
        <div className="flex items-center">
          <img
            data-testid={TestIds.header.logo}
            src={logoSvg}
            alt="123JOBS.COM"
            className="h-10"
          />
        </div>

        <div className="flex items-center">
          {isHomePage && (
            <Button
              data-testid={TestIds.header.cta}
              shape="rounded"
              className="min-w-[130px]"
              onClick={handleApplyClick}
            >
              {t('landing.header.cta')}
            </Button>
          )}

          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
};
